<template>

    <div class="">

        <userhud />

        <div>
            <div class="mb-4">
                <div class="fs-4 p-1 d-flex align-items-center justify-content-center bg-black text-white">
                    <div class="ps-1 text-uppercase">
                        start your challenge
                    </div>
                </div>
            </div>

            <button v-if="0" type="button" @click="$root.view('bust');">bust</button>
            
            <div class="m-2">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="text-uppercase fs-4">Count</div>
                    <div class="btn-group puzzlecount" role="group" >

                        <input v-if="diff==1" type="radio" class="btn-check" name="setup_puzzles" id="puzzles_d0" autocomplete="off" value="1" v-model="ppr">
                        <label v-if="diff==1" class="btn btn-outline-primary" for="puzzles_d0">1</label>

                        <input v-if="diff<3" type="radio" class="btn-check" name="setup_puzzles" id="puzzles_0" autocomplete="off" value="3" v-model="ppr">
                        <label v-if="diff<3" class="btn btn-outline-primary" for="puzzles_0">3</label>

                        <input type="radio" class="btn-check" name="setup_puzzles" id="puzzles_1" autocomplete="off" value="5" v-model="ppr">
                        <label class="btn btn-outline-primary" for="puzzles_1">5</label>

                        <input type="radio" class="btn-check" name="setup_puzzles" id="puzzles_2" autocomplete="off" value="10" v-model="ppr">
                        <label class="btn btn-outline-primary" for="puzzles_2">10</label>

                        <input type="radio" class="btn-check" name="setup_puzzles" id="puzzles_3" autocomplete="off" value="15" v-model="ppr">
                        <label class="btn btn-outline-primary" for="puzzles_3">15</label>
                    </div>
                </div>

                <div class="mt-3 d-flex align-items-center justify-content-between">
                    <div class="text-uppercase fs-4">puzzles</div>
                    <div class="btn-group diff" role="group" >
                        <input type="radio" class="btn-check" name="setup_diff" id="diff_1" autocomplete="off" value="1" v-model="diff">
                        <label class="btn btn-outline-primary text-uppercase ps-3 fs-6" for="diff_1">easy</label>

                        <input type="radio" class="btn-check" name="setup_diff" id="diff_2" autocomplete="off" value="2" v-model="diff">
                        <label class="btn btn-outline-primary text-uppercase fs-6" for="diff_2">all</label>

                        <input type="radio" class="btn-check" name="setup_diff" id="diff_3" autocomplete="off" value="3" v-model="diff">
                        <label class="btn btn-outline-primary text-uppercase pe-3 fs-6" for="diff_3">hard</label>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between mt-3">
                    <div class="text-uppercase fs-4">speed round</div>
                    <div class="btn-group diff" role="group" >
                        <input type="radio" class="btn-check" name="setup_timer" id="timer_2" autocomplete="off" value="0" v-model="timer">
                        <label class="btn btn-outline-primary text-uppercase fs-6" for="timer_2">off</label>
                        
                        <input type="radio" class="btn-check" name="setup_timer" id="timer_1" autocomplete="off" value="1" v-model="timer">
                        <label class="btn btn-outline-primary text-uppercase ps-2 pe-3 fs-6" for="timer_1">on</label>
                    </div>
                </div>
            </div>

            <div v-if="showScorecard" id="scorecard" class="mt-4" v-on:click.stop="closeScorecard()">
                <div :class="{ 'anim bounce-in-top' : showScorecard==1, 'anim puff-out-center' : showScorecard==2 }">
                    <div class="mb-4">
                        <div class="fs-5 p-1 d-flex align-items-center justify-content-center bg-black text-white">
                            <div class="ps-1 text-uppercase">
                                scoring
                            </div>
                        </div>

                        <div class="text-center fs-5 text-secondary">
                            Change play style above to update scoring
                        </div>
                    </div>

                    <div class="m-2">
                        <div class="d-flex align-items-start justify-content-between mt-1">
                            <div class="d-flex flex-column">
                                <div class="text-uppercase fs-5 text-success">Perfect Game</div>
                                <div class="text-secondary">Solve all puzzles with 100% success</div>
                                <div class="d-flex align-items-center text-secondary">
                                    <i class="fs-1 me-2" :class="gameStore.bonus.diff[userStore.user.options.diff].award.icon" :style="'color: ' + gameStore.options.ppr[userStore.user.options.ppr].color"></i> award every {{gameStore.bonus.diff[userStore.user.options.diff].award.wins  }}
                                </div>
                            </div>
                            <div class="fs-4 text-success text-end d-flex flex-column">
                                + {{ $root.calcBonus('base-perfect') + $root.calcBonus('immunity') }}
                                <span class="fs-6">+1 shield</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between mt-2">
                            <div>
                                <div class="text-uppercase fs-5 text-success">Perfect Solve</div>
                                <p class="text-secondary">Solve a single puzzle without errors</p>
                            </div>
                            <div class="fs-4 text-success">
                                + {{ $root.calcBonus('perfectsolve') }}
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between mt-1">
                            <div>
                                <div class="text-uppercase fs-5 text-success">High Performer</div>
                                <p class="text-secondary">Complete game with at least {{ gameStore.bonus.diff[userStore.user.options.diff].min }}% success</p>
                            </div>
                            <div class="fs-4 text-success">
                                + {{ $root.calcBonus('base') }}
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between mt-1" v-if="userStore.user.options.timer">
                            <div>
                                <div class="text-uppercase fs-5 text-success">Time Bonus</div>
                                <p class="text-secondary">Solve clue within bonus time <i class="text-success fs-3 game-icon game-icon-stopwatch"></i></p>
                            </div>
                            <div class="fs-4 text-success">
                                + {{ gameStore.bonus.diff[userStore.user.options.diff].timer }}
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between mt-1">
                            <div>
                                <div class="text-uppercase fs-5 text-danger">Performance Penalty</div>
                                <p class="text-secondary">Complete game below {{ gameStore.penalty.diff[userStore.user.options.diff].successRate }}% success</p>
                            </div>
                            <div class="fs-4 text-danger d-flex flex-column align-items-end">
                                <span>- {{ $root.calcPenalty() }}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-start justify-content-between mt-1" v-if="userStore.user.options.timer">
                            <div>
                                <div class="text-uppercase fs-5 text-danger">Time Penalty</div>
                                <p class="text-secondary">Solve clue after timer expires <i class="text-danger fs-3 game-icon game-icon-stopwatch"></i></p>
                            </div>
                            <div class="fs-4 text-danger d-flex flex-column align-items-end">
                                <span>- {{ gameStore.penalty.diff[userStore.user.options.diff].timer }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center mb-2" >
                        <i class="fs-1 game-icon game-icon-cancel icon-md"  v-on:click.stop="closeScorecard()"></i>
                    </div>
                </div>
            </div>

            <div class="mt-5 text-center" v-if="!showScorecard">
                <button type="button" class="tron sm" @click="startGame()">
                    <span></span><span></span><span></span><span></span>Let's Begin
                </button>
            </div>

            <div class="mt-5 text-center clickfx" v-if="!showScorecard" @click="showScorecard=1">
                <span href="#" class="text-primary text-uppercase">scoring guide</span>
            </div>
        
        </div>

        <div v-if="userStore.users.welcome" id="welcome" class="mt-4">
            <div :class="{ 'anim bounce-in-top' : userStore.users.welcome==1, 'anim puff-out-center' : userStore.users.welcome==2 }">
                <div class="mb-4">
                    <div class="fs-5 p-1 d-flex align-items-center justify-content-center bg-black text-white">
                        <div class="ps-1 text-uppercase">
                            meet professor Nohzal
                        </div>
                    </div>

                    <div class="px-3 pt-3">
                        <div class="text-center fs-5 text-secondary">
                            <h1 class="text-primary">Professor Nohzal has a message for you!</h1>
                            <h3 class="text-black">You can repeat Professor Nohzal's welcome later by long tapping his picture at the top of this start screen.</h3>
                        </div>

                        <div class="d-flex flex-column align-items-center justify-content-center my-1" >
                            <button type="button" class="btn btn-primary rounded-0 text-uppercase" v-on:click.stop="closeWelcome()">Listen Now</button>
                            <a class="mt-2 fs-6 text-uppercase" href="#" @click="userStore.users.welcome=0">no thanks</a>                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="preload-puzzlefont">p</div>

</template>

<script>
import userhud from "@/components/userhud.vue";
import { useUserStore,useGameStore } from '@/gamestore.js';

export default {
    components: { 
        userhud
    },
    data: () => ({  
        userStore: useUserStore(),
        gameStore: useGameStore(),
        showScorecard: 0,
    }),
    computed: {
        sfxLib: function() {
            return this.$root.sfxLib;
        },
        diff: {
            get() {
                return this.userStore.user.options.diff;
            },
            set(val) {
                this.userStore.user.options.diff = Number(val);
            }
        },
        ppr: {
            get() {
                return this.userStore.user.options.ppr;
            },
            set(val) {
                this.userStore.user.options.ppr = Number(val);
            }
        },
        timer: {
            get() {
                return this.userStore.user.options.timer;
            },
            set(val) {
                this.userStore.user.options.timer = Number(val);
            }
        }
    },
    methods: {
        startGame: function(){
            if ( this.$parent.isPaid() ) {
                this.$root.view('play');    
            } else {
                if ( this.userStore.users.freeplays > 0 ) {
                    this.$root.view('play');    
                } else {
                    this.$root.view('upgrade');
                }
            }
            
        },
        closeScorecard: function() {
            this.showScorecard=2;
            var self = this;

            setTimeout(function(){
                self.showScorecard = 0;
            },250);
        },
        closeWelcome: function() {
            this.$root.sfxObj.welcome = this.$root.playSfx(this.$root.sfxObj.welcome,this.$root.sfxLib.speech.welcome,{
                tts:1,
                logoGrow: 1,
                callback:function(self){
                    self.$root.logoGrow = 2;

                }
            });
            this.userStore.users.welcome = 0;

        },
    },
    updated() {
        if ( this.diff == 3 && this.ppr < 5 ) {
            this.ppr = 5;
        }
        if ( this.diff == 2 && this.ppr < 3 ) {
            this.ppr = 3;
        }
    },
    mounted() {
        this.gameStore.currentGame.gameboard.isStart = 0;
        
        new Howl({
              src: require('@/assets/sfx/tts/justsaying-welcome.mp3'),
              html5: true,
              format: ['mp3'],
              preload: true,
              autoplay: false,
        });
    },
}

</script>

<style>
label[for='diff_1'],
label[for='timer_2'],
.puzzlecount label:first-of-type {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
}

label[for='diff_2X'] {
    border-top-right-radius: var(--bs-btn-border-radius) !important;
    border-bottom-right-radius: var(--bs-btn-border-radius) !important;
}

label[for='diff_3'],
label[for='timer_1'],
.puzzlecount label:last-of-type {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
}

.puzzlecount label {
    min-width:3rem;
    /* border-radius: 50% !important; */
    /* width: 2.5rem; */
}

#scorecard {
    transform: scale(0.8);
    position: absolute;
    top: 5%;
    width: 100%;
    z-index:100;
    left:0;
}

#welcome {
    position: absolute;
    top: 32%;
    width: 100%;
    max-width: 670px;
    z-index:100;
    left:0;
    right:0;
    margin: auto;
}

#scorecard > div,
#welcome > div {
    background-color: #FFF;
    border:1px solid #000;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.75);
    overflow-y: auto;
}
</style>